<template>
  <div class="d-flex justify-start align-center mt-1">
    <BaseActionsButton
      id="detailsTrip"
      name="detailsTrip"
      iconName="mdi-eye"
      iconColor="primary"
      customClass="mr-2"
      tooltipMessage="View Details"
      @click="viewDetails()"
    ></BaseActionsButton>
    <BaseActionsButton
      id="editTrip"
      name="editTrip"
      iconName="mdi-pencil"
      iconColor="primary"
      customClass="mr-2"
      tooltipMessage="Edit Details"
      @click="editTrip()"
    ></BaseActionsButton>
  </div>
</template>

<script>
export default {
  methods: {
    editTrip() {
      this.params.context.parentComponent.editTrip(this.params.data.id);
    },
    viewDetails() {
      this.params.context.parentComponent.viewDetails(this.params.data.id);
    },
  },
};
</script>

<style>
</style>